/**
 * Stats Cards Components - Desktop and Mobile variants
 */
import { Phone, Calendar, FileText, Award } from "lucide-react";

// Desktop Stats Card
export const DesktopStatsCard = ({ icon: Icon, value, label, bgColor, iconColor, loading }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
    <div className="flex items-center gap-4">
      <div className={`w-12 h-12 rounded-xl ${bgColor} flex items-center justify-center`}>
        <Icon size={24} className={iconColor} />
      </div>
      <div>
        <p className="text-2xl font-bold text-gray-900">{loading ? "…" : value}</p>
        <p className="text-sm text-gray-500">{label}</p>
      </div>
    </div>
  </div>
);

// Mobile Stats Counter
export const StatsCounter = ({ stats, loading, userRole }) => {
  const getScopeLabel = () => {
    if (userRole === 'team_leader') return '(Tim)';
    if (userRole === 'manager' || userRole === 'admin') return '(Svi)';
    return '';
  };
  const scopeLabel = getScopeLabel();
  
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 mb-4 animate-fadeIn">
      {scopeLabel && (
        <div className="text-xs text-gray-500 text-center mb-2 font-medium">
          Statistika ovaj mjesec {scopeLabel}
        </div>
      )}
      <div className="grid grid-cols-4 gap-3">
        {[
          { label: "Pozivi", value: stats.calls, color: "blue" },
          { label: "Sastanci", value: stats.meetings, color: "green" },
          { label: "Ponude", value: stats.offers, color: "amber" },
          { label: "Akviz.", value: stats.acquisitions, color: "rose" },
        ].map(({ label, value, color }) => (
          <div key={label} className="text-center">
            <div className={`text-xl font-bold text-${color}-600 ${loading ? 'animate-pulse' : ''}`}>
              {loading ? "-" : value}
            </div>
            <div className="text-[10px] text-gray-500 uppercase tracking-wide">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Desktop Stats Grid
export const DesktopStatsGrid = ({ stats, loading }) => (
  <div className="grid grid-cols-4 gap-4 mb-4">
    <DesktopStatsCard 
      icon={Phone} 
      value={stats.calls} 
      label="Poziva ovaj mjesec" 
      bgColor="bg-blue-50" 
      iconColor="text-[#1B3F8F]" 
      loading={loading} 
    />
    <DesktopStatsCard 
      icon={Calendar} 
      value={stats.meetings} 
      label="Sastanaka" 
      bgColor="bg-green-50" 
      iconColor="text-green-600" 
      loading={loading} 
    />
    <DesktopStatsCard 
      icon={FileText} 
      value={stats.offers} 
      label="Ponuda" 
      bgColor="bg-purple-50" 
      iconColor="text-purple-600" 
      loading={loading} 
    />
    <DesktopStatsCard 
      icon={Award} 
      value={stats.acquisitions} 
      label="Akvizicija" 
      bgColor="bg-amber-50" 
      iconColor="text-amber-600" 
      loading={loading} 
    />
  </div>
);
